/* Native header disclosures. No persistence, requests or measurement. */
(function () {
  var selector = '.oxp-mobile-nav[open], .oxp-search-disclosure[open]';
  function menus() { return document.querySelectorAll(selector); }
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = menus();
    if (!open.length) return;
    event.preventDefault();
    var menu = open[0];
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('click', function (event) {
    menus().forEach(function (menu) {
      if (!menu.contains(event.target) || event.target.closest('.oxp-mobile-nav nav a, .oxp-search-links a, [data-search-dismiss]')) menu.open = false;
    });
  });
  document.addEventListener('focusin', function (event) {
    menus().forEach(function (menu) { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('toggle', function (event) {
    var menu = event.target;
    if (!menu.matches || !menu.matches('.oxp-mobile-nav, .oxp-search-disclosure') || !menu.open) return;
    menus().forEach(function (other) { if (other !== menu) other.open = false; });
    if (menu.matches('.oxp-search-disclosure')) {
      requestAnimationFrame(function () {
        if (!menu.open) return;
        var input = menu.querySelector('input[type="search"]');
        if (input) input.focus({ preventScroll: true });
      });
    }
  }, true);
})();
